import SignupVerify from "../../../../jsx/pages/Agent/SignupVerify";

const SignupVerifyWrapper = function () {
  return <SignupVerify />;
};

export default constore(SignupVerifyWrapper);
